export default __webpack_public_path__ + "logo-with-text-61910345086f8a418bce867653690f700ea1c234851ede2e65f3d5aefc49e665.svg";